import script from "./MangaTranslation.vue?vue&type=script&setup=true&lang=js"
export * from "./MangaTranslation.vue?vue&type=script&setup=true&lang=js"

import "./MangaTranslation.vue?vue&type=style&index=0&id=51974a4a&scoped=true&lang=css"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51974a4a"]])

export default __exports__